export default "__VITE_ASSET__BOlLiYcO__"